import React, { useState } from "react";
import { Outlet, NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Settings, Crown, Utensils, Image as ImageIcon, Star, HelpCircle, Newspaper,
  Users, ClipboardList, FileText, Receipt, FolderOpen, LogOut, Menu, X, Briefcase, KeyRound
} from "lucide-react";
import { useAuth } from "../../lib/auth";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/leads", label: "Leads & CRM", icon: ClipboardList },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/quotations", label: "Quotations", icon: FileText },
  { to: "/admin/invoices", label: "GST Invoices", icon: Receipt },
  { div: true, label: "Website CMS" },
  { to: "/admin/settings", label: "Site Settings", icon: Settings },
  { to: "/admin/packages", label: "Packages", icon: Crown },
  { to: "/admin/menus", label: "Menus", icon: Utensils },
  { to: "/admin/services", label: "Services", icon: Briefcase },
  { to: "/admin/gallery", label: "Gallery", icon: ImageIcon },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/faq", label: "FAQs", icon: HelpCircle },
  { to: "/admin/blog", label: "Blog", icon: Newspaper },
  { to: "/admin/media", label: "Media Library", icon: FolderOpen },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className="min-h-screen bg-ivory flex">
      {/* Sidebar */}
      <aside className={`fixed lg:static z-40 w-72 h-screen bg-navy-900 border-r border-gold/15 transition-transform lg:translate-x-0 ${open ? "translate-x-0" : "-translate-x-full"}`} data-testid="admin-sidebar">
        <div className="p-5 border-b border-gold/15">
          <div className="serif text-2xl text-ivory">Shree Balaji</div>
          <div className="text-gold tracking-royal text-[10px] uppercase mt-1">Royal Control Room</div>
        </div>
        <div className="overflow-y-auto h-[calc(100vh-180px)] py-4 px-3">
          {NAV.map((n, i) => n.div ? (
            <div key={i} className="text-gold/50 text-[10px] tracking-[0.25em] uppercase mt-6 mb-2 px-3">{n.label}</div>
          ) : (
            <NavLink
              key={n.to} to={n.to} end={n.end}
              onClick={() => setOpen(false)}
              className={({ isActive }) => `sidebar-item ${isActive ? "active" : ""}`}
              data-testid={`sidebar-${n.to.split("/").pop()}`}
            >
              <n.icon size={16} strokeWidth={1.5} /> {n.label}
            </NavLink>
          ))}
        </div>
        <div className="absolute bottom-0 left-0 right-0 p-4 border-t border-gold/15">
          <div className="text-ivory text-sm">{user?.name || "Admin"}</div>
          <div className="text-ivory/50 text-xs">{user?.email}</div>
          <div className="flex gap-2 mt-3">
            <button onClick={() => nav("/admin/change-password")} className="flex-1 text-xs text-ivory/70 hover:text-gold flex items-center justify-center gap-2 py-2 border border-gold/20 rounded" data-testid="sidebar-change-pw">
              <KeyRound size={12} /> Password
            </button>
            <button onClick={() => { logout(); nav("/admin/login"); }} className="flex-1 text-xs text-ivory/70 hover:text-gold flex items-center justify-center gap-2 py-2 border border-gold/20 rounded" data-testid="sidebar-logout">
              <LogOut size={12} /> Logout
            </button>
          </div>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="lg:hidden fixed top-0 inset-x-0 bg-navy-900 border-b border-gold/20 z-30 flex items-center justify-between p-3">
        <button onClick={() => setOpen(!open)} className="text-gold p-2" data-testid="admin-mobile-toggle">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
        <div className="serif text-ivory">Balaji Admin</div>
        <div className="w-8" />
      </div>

      <main className="flex-1 lg:ml-0 mt-14 lg:mt-0 min-h-screen overflow-x-hidden">
        <Outlet />
      </main>
    </div>
  );
}
